<div class="cp-tooltip-inner">
  <ng-container *ngTemplateOutlet="content; context: { $implicit: data }"></ng-container>
</div>
<div class="caret"></div>
